import SuperagentApi from '../assets/utils/superagent'

const modelSetting = Wiz.globalSettings?.globalConfig?.modelSetting || {}
const superagentApi = new SuperagentApi({
  baseUrl: `${Wiz.GetModuleServer('cloud-render-management')}/customProxy`,
  headers: {
    proxyHost: `${modelSetting.cloudProtocol === 'wss' ? 'https' : 'http'}://${
      modelSetting.cloudServerPath
    }`,
  },
})
export default class CloudProxyService {
  // 连接列表
  static async getConnectionList(payload) {
    const [err, res] = await superagentApi.get('/sessions', {
      params: { ...payload },
    })
    return [err, res]
  }
  // 连接列表
  static async getNodeConnectionList(payload) {
    const superagentNodeApi = new SuperagentApi({ baseUrl: modelSetting.engineNodeServer })
    const [
      err,
      res,
    ] = await superagentNodeApi.get(
      `/api/cloud-render-node/get-scene-distribute-list/${payload.id}`,
      { params: {} }
    )
    return [err, res]
  }
  // 获取客户端的ip地址
  static async getIP(payload) {
    const [err, res] = await superagentApi.get('/allIP', {
      params: { ...payload },
    })
    return [err, res]
  }
  // 获取引擎状态
  static async getClusters(payload) {
    const [err, res] = await superagentApi.get('/clusters', {
      params: { ...payload },
    })
    return [err, res]
  }
  // 强制终止引擎
  static async forceTerminate(payload) {
    const [err, res] = await superagentApi.get('/kill', {
      params: { ...payload },
    })
    return [err, res]
  }
}
